export enum NetworkAnalysisType {
  ENTITY = 'ENTITY',
  INSTRUMENT = 'INSTRUMENT',
}
